import { BaseEntity } from ".";

export class SkillUnallocatedEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Skill";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: any = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Name
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: "Unallocated SP",
      };
      const name = "Unallocated SP";
      entity.text = name;
      // - Active Skill Level
      entity.properties["active_skill_level"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: 0,
        numberFormat: "##0",
      };
      entity.properties["trained_skill_level"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: 0,
        numberFormat: "##0",
      };
      // - Skillpoints in Skill
      entity.properties["skillpoints_in_skill"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: props,
        numberFormat: "##0",
      };
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
